import { render, staticRenderFns } from "./BaseDrinkCounter.vue?vue&type=template&id=22b8eaf9&"
import script from "./BaseDrinkCounter.vue?vue&type=script&lang=ts&"
export * from "./BaseDrinkCounter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports